// Performs left-to-right function composition.
export const pipe = <TBaseValue>(...fns: ((baseValue: TBaseValue) => TBaseValue)[]) => {
    return (baseValue: TBaseValue) => fns.reduce((prevResult, currentFunction) => currentFunction(prevResult), baseValue);
};
// Performs left-to-right function composition.
export const pipe = <TBaseValue>(...fns: ((baseValue: TBaseValue) => TBaseValue)[]) => {
    return (baseValue: TBaseValue) => fns.reduce((prevResult, currentFunction) => currentFunction(prevResult), baseValue);
};
